import request from "@/utils/request";
import service from '@/utils/axios-v2'

export function getHistories(page = 1, size = 10) {
  return service({
    url: "/fleet/subscription/history",
    params: { page, size },
    headers: {
      "portal-token": true
    }
  });
}

export function changeSubscription(name) {
  return service({
    url: "/fleet/subscription/change",
    params: { subscription: name },
    method: "post",
    headers: {
      "portal-token": true
    }
  });
}

export function changeSeat({ operatorSeatNum, driverSeatNum }) {
  return request({
    url: "/fleet/subscription/seat/change",
    params: { operator: operatorSeatNum, driver: driverSeatNum },
    method: "post",
    headers: {
      "portal-token": true
    }
  });
}

export function getSubscription() {
  return service({
    url: "/fleet/get_subscription_info",
    headers: {
      "portal-token": true
    }
  });
}

export function getPackageList() {
  return request({
    url: "/fleet/product/query",
    method: "post",
    headers: {
      "portal-token": true
    }
  });
}

export function getOrderInfo(subscriptionID, token) {
  return service({
    url: "/fleet/subscription/query",
    params: { subscriptionID },
    method: "post",
    headers: { "portal-token": token }
  });
}

export function firstOrderPay({ subscriptionID, token, email, url }) {
  let params = {}
  if (email) {
    params = { email, url }
  }
  return service({
    url: `/fleet/subscription/${subscriptionID}/pay`,
    method: "put",
    params: params,
    headers: { "portal-token": token }
  });
}

export function contactSalesman() {
  return service({
    url: "/fleet/contact_us_send_to_lucrativ",
    headers: { "portal-token": true }
  });
}

/**
 * 修改套餐及seat数量
 * @param {*} params 
 * @returns 
 */
export function changeSeatAndSub(params) {
  return request({
    url: "/fleet/subscription/changeV2",
    headers: {
      "portal-token": true
    },
    method: "post",
    params,
  })
}

/**
 * 试用账号修改套餐
 * @param {*} params 
 * @returns 
 */
export function trailReactive(params) {
  return request({
    url: "/fleet/subscription/reactive_trial",
    headers: {
      "portal-token": true
    },
    method: "get",
    params
  })
}

/**
 * beta_trail修改套餐
 * @param {*} params 
 * @returns 
 */
 export function betaTrailReactive(params) {
  return request({
    url: "/fleet/subscription/reactive_beta_trial",
    headers: {
      "portal-token": true
    },
    method: "get",
    params
  })
}

export function getSubscriptionProductList() {
  return service({
    url: '/fleet/product',
    method: 'get'
  })
}


export function getDiallerPendingPayments() {
  return service({
    url: '/fleet/order/pending/payment',
    headers: {"portal-token": true},
    method: "get",
  })
}
